import React from "react";
import { List, ListItem, ListItemText } from "@mui/material";
import { ModuleTextWrapper, SideBarWrapper } from "../StyledComponent";
import { citizenBaseUrl, Sidebarlabels } from "../data";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFormMTDocs } from "@egovernments/digit-ui-module-core/src/redux/actions/formMT";

const Sidebar = ({ Sidebarlabels }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleItemClick = (label) => {
    if (label.text === "Logout") {
      Digit.UserService.logout();
      history.push(citizenBaseUrl);
    } else if (label.text === "My Applications" || label.text === "Dashboard") {
      Digit?.SessionStorage.del("FORMLANDUSE");
      Digit?.SessionStorage.del("FORM_PURCHASABLE_FAR");
      Digit?.SessionStorage.del("LANDUSE_CURRENT_TAB");
      Digit?.SessionStorage.del("LANDUSE_CURRENT_SUBTAB");
      Digit?.SessionStorage.del("PURCHASABLE_FAR_TAB");
      Digit?.SessionStorage.del("PURCHASABLE_FAR_SUBTAB");

      dispatch(resetFormMTDocs());
    }
  };

  return (
    <SideBarWrapper>
      <ModuleTextWrapper>Module Overview</ModuleTextWrapper>
      <List>
        {Sidebarlabels?.map((label, index) => (
          <ListItem
            button
            key={index}
            onClick={() => handleItemClick(label)}
            component={label.text === "Logout" ? "div" : Link}
            to={label.text !== "Logout" ? label.path : undefined}
            sx={{
              marginBottom: "1rem",
              "&:hover": {
                backgroundColor: "#3a4248",
              },
            }}
          >
            <ListItemText primary={label.text} />
          </ListItem>
        ))}
      </List>
    </SideBarWrapper>
  );
};

export default Sidebar;
